import settings from '@/settings'

const conexao = (headers, data) => {
    let url = `${settings.fisioApi}/sendzapi/`
    const request = {
        method: data.method,
        mode: 'cors',
        headers: headers
    }
    if (data.parametros) {
        Object.keys(data.parametros).forEach((filter) => {
            url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data.parametros[filter]}`
        })
    }

    if (data.method === 'GET') {
    request.cache = 'default'
    } else request.body = JSON.stringify(data.body)
    return fetch(url, request)
  }

  const enviarCodigo = (data, headers) => {
    return fetch(`${settings.fisioApi}/sendzapi/EnviarCodigoVerificacao/`, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(data),
        cache: 'default',
        headers: headers
      })
  }

  const confirmarCodigo = (data, headers) => {
    return fetch(`${settings.fisioApi}/sendzapi/VerificaCodigoWhatsApp/`, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(data),
        cache: 'default',
        headers: headers
      })
  }

export default {
    conexao,
    enviarCodigo,
    confirmarCodigo
}
